import {
  getAllAssetsTypes,
  getAssetTypeById,
  updateAssetType,
} from "../../../Redux/Assets/AssetsActions";
import validator, { ValidationField } from "../../../Util/validator";
import { AssetSubType } from "../../../Redux/Assets/AssetsReducer";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { Link, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import styles from "./UpdateAssetType.module.scss";
import { useEffect, useState } from "react";

function UpdateAssetType() {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const {
    updateAssetTypeLoading,
    assetTypesLoading,
    assetTypesData,
    getAssetTypeByIdLoading,
    assetTypeByIdData,
  } = useSelector((state: RootState) => state.assets);

  const [type, setType] = useState<string>("");
  const [parentTypeId, setParentTypeId] = useState<string>("");

  const [errors, setErrors] = useState<{
    type: string;
    parentTypeId: string;
  }>({
    type: "",
    parentTypeId: "",
  });

  const updateAssetTypeHandler = () => {
    const fields: ValidationField[] = [
      {
        key: "type",
        type: "text",
        value: type,
      },
    ];

    const { errors: fieldErrors, isValid } = validator(fields);
    setErrors({ ...errors, ...fieldErrors });

    if (isValid) {
      if (!updateAssetTypeLoading && id) {
        const successHandler = () => {
          navigate("/admin/assets", {
            replace: true,
          });
        };

        dispatch(
          updateAssetType({
            type,
            parentTypeId: parentTypeId ? parseInt(parentTypeId) : null,
            assetTypeId: parseInt(id),
            successHandler,
          }),
        );
      }
    }
  };

  useEffect(() => {
    dispatch(getAllAssetsTypes());
    if (id) {
      dispatch(getAssetTypeById({ assetTypeId: parseInt(id) }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (assetTypeByIdData) {
      setType(assetTypeByIdData?.type || "");
      setParentTypeId(assetTypeByIdData?.parentTypeId?.toString() || "");
    }
  }, [assetTypeByIdData]);

  return (
    <div className={styles.mainContainer}>
      <Link to="/admin/assets" replace className={styles.backButtonContainer}>
        <button className={styles.button}>
          <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
          Back to Assets
        </button>
      </Link>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Update Asset Type</h1>
      </div>
      <div className={styles.formContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Type</p>
          <input
            type="text"
            className={styles.input}
            value={type}
            onChange={(e) => setType(e.target.value)}
          />
          <p className={styles.error}>{errors.type}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Parent Type</p>
          <select
            className={styles.input}
            value={parentTypeId}
            onChange={(e) => setParentTypeId(e.target.value)}
          >
            <option value="">None</option>
            {assetTypesData
              ?.filter(
                (assetType) => assetType?.assetTypeId !== parseInt(id || ""),
              )
              ?.map((assetType, i) => (
                <option key={i} value={assetType?.assetTypeId}>
                  {assetType?.type}
                </option>
              ))}
          </select>
          <p className={styles.error}>{errors.parentTypeId}</p>
        </div>

        {(updateAssetTypeLoading ||
          assetTypesLoading ||
          getAssetTypeByIdLoading) && <Loading />}

        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={updateAssetTypeHandler}>
            Update Asset Type
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateAssetType;
